import React from 'react';
import { Layout, theme } from 'antd';
import { themedShellFor } from './themedShellRoutes';

// Actual routed shell body; extracting this preserves legacy/full-height
// layout branches while making their theme composition directly testable.
function Body({ themed, isQV4, isMobile, colorBgContainer, borderRadiusLG, legacyFooterColor, children, footer }) {
  const { token } = theme.useToken();
  return <>
    <Layout.Content data-testid="shell-content" style={themed
      ? { margin: 0, padding: isMobile ? 8 : 16, background: token.colorBgLayout, color: token.colorText }
      : isQV4 ? { flex: 1, overflow: 'hidden', minHeight: 0, margin: 0 } : { margin: isMobile ? '0 4px' : '0 16px' }}>
      <div data-testid="shell-inner" style={themed
        ? { padding: themed.canvas ? 0 : isMobile ? 8 : 24, minHeight: 360, background: themed.canvas ? token.colorBgLayout : token.colorBgContainer, color: token.colorText, borderRadius: themed.canvas ? 0 : borderRadiusLG }
        : isQV4 ? { height: '100%', overflow: 'hidden' } : { padding: isMobile ? 8 : 24, minHeight: 360, background: colorBgContainer, borderRadius: borderRadiusLG }}>
        {children}
      </div>
    </Layout.Content>
    {!isQV4 && <Layout.Footer data-testid="shell-footer" style={{ textAlign: 'center', fontSize: isMobile ? 10 : 11, color: themed ? token.colorTextSecondary : legacyFooterColor, padding: isMobile ? '12px 16px' : '14px 16px', background: themed ? token.colorBgLayout : 'transparent' }}>{footer}</Layout.Footer>}
  </>;
}
export default function ShellPageBody(props) {
  const themed = themedShellFor(props.pathname);
  const PageTheme = themed?.PageTheme || React.Fragment;
  return <PageTheme><Body {...props} themed={themed} /></PageTheme>;
}
